import * as React from 'react';

import { Grid } from "@material-ui/core";
import { CardBarChartMarketAndGroupAndBookstore } from '../../../../shared/layout/components/CardBarChartMarketAndGroupAndBookstore';

// tslint:disable-next-line:no-empty-interface
export interface IMarketShareBookstoreCategoryBisacShareProps {
    data: any;
    loading: boolean;
    type: string;
}

// tslint:disable-next-line:no-empty-interface
export interface IMarketShareBookstoreCategoryBisacShareState {
}

export class MarketShareBookstoreCategoryBisacShare extends React.Component<IMarketShareBookstoreCategoryBisacShareProps, IMarketShareBookstoreCategoryBisacShareState> {

    public render() {
        return  (
            <Grid item={true} xs={6} md={6}>
                <CardBarChartMarketAndGroupAndBookstore 
                    data={this.props.data.marketCategoryBookstoreSalesByTheme}
                    loading={this.props.loading}
                    title={'Vendas por Categoria Bisac - 30 Dias'}
                    type={this.props.type}
                />
            </Grid>
        )
    }
}



// WEBPACK FOOTER //
// ./src/component/market/bookstore/categoryShare/bisacShare/MarketShareBookstoreCategoryBisacShare.tsx